import { render } from "./Paso4InstruccionesComponent.vue?vue&type=template&id=54ea8cd4"
import script from "./Paso4InstruccionesComponent.vue?vue&type=script&lang=js"
export * from "./Paso4InstruccionesComponent.vue?vue&type=script&lang=js"

import "./Paso4InstruccionesComponent.vue?vue&type=style&index=0&id=54ea8cd4&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__